import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { LytTreeAbstract } from './lyt-tree-abstract';
import { LytTreeControl } from './lyt-tree-control';
import { LayoutDirection } from './jss-types';

export class LytTreeContainer extends LytTreeAbstract {

   constructor(
      protected _layoutDirection: LayoutDirection
   ) {
      super();
   }

   public isLayoutColumn(): boolean {return this._layoutDirection === 'COLUMN'; }
   public isLayoutRow(): boolean {return this._layoutDirection === 'ROW'; }

   public getFirstChildContainer() {
      for (const item of this._children) {
         if (item instanceof LytTreeContainer) {
            return item;
         }
      }
      return null;
   }

   public addContainer(child: LytTreeContainer): LytTreeContainer {
      if (!child) {
         console.warn('Passed param: miss child');
      }
      this._children.push(child);
      child._parent = this;
      return child;
   }

   public addControl(child: LytTreeControl): LytTreeControl {
      if (!child) {
         console.warn('Passed param: miss child');
      }
      this._children.push(child);
      child.parent = this;
      return child;
   }

   public reveDumpLytTree(indent: string) {
      const s = indent + this._layoutDirection;
      console.log(s);

      // children
      for (const item of this._children) {
         item.reveDumpLytTree(indent + '  ');
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/lyt-tree-container.ts